import { getPartialSubtaskFromSubtodo, updateSubtaskService } from 'owa-todo-service';
import { getTodoCache } from '../todoCache';
import { Subtodo } from 'owa-todo-types';
import findInArray from './findInArray';

export async function updateSubtodo(
    subtodoUpdates: Partial<Subtodo>,
    parentTodoId: string,
    subtodoId: string
): Promise<boolean> {
    const updates = getPartialSubtaskFromSubtodo(subtodoUpdates);
    const originalSubtodos = getTodoCache().selectItemById(parentTodoId)?.Subtasks;
    if (!updates || !originalSubtodos) {
        return true;
    }

    const findInArrayResult = findInArray(originalSubtodos, subtodo => subtodo.Id === subtodoId);
    if (!findInArrayResult) {
        return true;
    }

    // copy the original subtodos to so mobx can react to the array reference change
    const updatedSubtodos = [...originalSubtodos];
    updatedSubtodos[findInArrayResult.index] = { ...findInArrayResult.item, ...subtodoUpdates };

    // add local lie
    getTodoCache().updateItem(parentTodoId, { Subtasks: updatedSubtodos });

    // kick off subtodo update
    const successfullyUpdated = await updateSubtaskService(parentTodoId, subtodoId, updates);

    // remove the updates if the update operation fails
    if (!successfullyUpdated) {
        getTodoCache().updateItem(parentTodoId, { Subtasks: originalSubtodos });
    }

    return successfullyUpdated;
}
